import {isDonator, isLoggedIn} from "./Authentication";

export function getGuestLimit() {
  return "10";
}

export function getRegisteredLimit() {
  return "20";
}

export function getDonatorLimit() {
  return "50";
}

export function getMyLimit() {
  if (isLoggedIn()) {
    return isDonator() ? getDonatorLimit() : getRegisteredLimit();
  } else {
    return getGuestLimit();
  }
}
